import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

const dropDown = '/img/drop-down-2.svg';
const dropUp = '/img/drop-up-2.svg'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginBottom: 16,
    marginTop: 24,
    minHeight: 104,
    padding: '16px 24px 24px 24px',
    backgroundColor: 'white',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
    borderRadius: 4,
  },
  title: {
    fontSize: 22,
    color: '#013957',
    borderBottom: 'thin solid #e7e7e7',
    paddingBottom: 8,
    marginBottom: 23,
    width: '100%',
    fontWeight: 'bold',
  },
  text: {
    fontSize: 16,
    textAlign: 'justify',
    color: '#484848',
    lineHeight: 'normal',
    '@media (max-width: 768px)': {
      fontSize: 14
    }
  },
  seeMore: {
    fontWeight: 'bold',
    color: '#10587f',
    lineHeight: 'normal',
    marginRight: 8,
  },
  expandButton: {
    display: 'flex',
    marginTop: 24,
    color: '#013957',
    cursor: 'pointer',
    width: 'fit-content',
  },
  summaryContentHidden: {
    marginTop: 23,
    alignSelf: 'start',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  summaryContent: {
    marginTop: 23,
    alignSelf: 'start',
    width: '100%'
  },
  formatExperienceOpen: {
    fontFamily: "Lato",
    lineHeight: '27px',
    height: 'auto',
    color:'#484848'
  },
  formatExperienceCollapsed: {
    fontFamily: "Lato",
    lineHeight: '27px',
    height: '110px',
    textOverflow: "ellipsis",
    overflow: "hidden",
    color:'#484848'
  },
  contentMainSeeMore: {
    display: "flex",
    flexDirection: "row",
    marginTop: '24px'
  },
  contentSeeMore: {
    display: "flex",
    flexDirection: "row",
    margin: "auto",
    cursor: "pointer"
  },
  seeMore: {
    fontSize: '16px',
    color: "#013957",
    fontWeight: "bold",
    textAlign: "center",
    marginTop: "10px",
  }
}));

const ExpansionPanel = withStyles({
  root: {
    color: '#484848',
    marginBottom: 10,
    borderRadius: 4,
    backgroundColor: 'white',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
    marginTop: 24,
  },
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    flexFlow: 'column',
    padding: 0,
    minHeight: 56,
    position: 'relative',
    cursor: 'auto',

  },
  content: {
    margin: 0,
    width: '100%',
    flexFlow: 'column',
    //alignItems: 'center',
    padding: '16px 24px',
    cursor: 'auto',
    '&$expanded': {
      margin: 0,
    },
  },
  expandIcon: {
    color: '#013957',
  },

  expanded: {
    //margin:0
  },
})(MuiExpansionPanelSummary);

var Scroll = require('react-scroll');
var Element = Scroll.Element;
var scroller = Scroll.scroller;

const CardExperience = props => {
  const { authClient, experience } = props;
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleChange = (event) => {
    console.log('expanded', expanded)
    if (expanded === false) {
      setExpanded(true);
    } else {
      setExpanded(false);
      scroller.scrollTo('scrollToExperience', {
        duration: 1000,
        smooth: true,
        offset: -100
      })
    }
  };

  return (

    <Element name="scrollToExperience">
      <div className={classes.root}>
        <p className={classes.title}>Experiencia {expanded}</p>
        {experience && experience ? <div id="textExperience" className={classes.summaryContent}>
          <div className={expanded ? classes.formatExperienceOpen : classes.formatExperienceCollapsed} dangerouslySetInnerHTML={{ __html: experience && experience }}></div>
        </div> : ''}
        <div className={classes.contentMainSeeMore}>
          <div className={classes.contentSeeMore} onClick={handleChange} >
            {expanded === false ?
              <>
                <p className={classes.seeMore}> Ver más</p>
                <img src={dropDown} alt="drop down" />  </> :
              <>
                <p className={classes.seeMore}> Ver menos</p>
                <img src={dropUp} alt="drop down" /> </>
            }
          </div>
        </div>
      </div>
    </Element>
  );
};

export default CardExperience;
